// extracted by mini-css-extract-plugin
module.exports = {"header":"acceptInvitation_header__2Sv2H","invitationError":"acceptInvitation_invitationError__1P-zX"};